/* global axios */
import ApiClient from './ApiClient';

// Sprint #46: account-wide read-only listing das BmtBotSessions :active
// pra UI de banner sticky no header + badge na lista de conversas.
// URL: /api/v1/accounts/:account_id/bmt_bot_activity
class BmtBotActivityAPI extends ApiClient {
  constructor() {
    super('bmt_bot_activity', { accountScoped: true });
  }
}

export default new BmtBotActivityAPI();
